// App.js
import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider, AuthContext } from './context/AuthContext';
import PrivateRoute from "./components/PrivateRoute";
import Navbar from "./components/Navbar";
import MasterSiteManager from "./components/MasterSiteManager";
import SiteManager from "./components/SiteManager";
import TodayReportViewer from "./components/TodayReportViewer";
import DailyReportViewer from "./components/DailyReportViewer";
import UserManager from "./components/UserManager";
import SiteViewer from "./components/SiteViewer";
import ReportTrigger from "./components/ReportTrigger";
import RegularSMSViewer from "./components/RegularSMSViewer";
import LoginPage from "./components/LoginPage";
import NavbarAdmin from "./components/NavbarAdmin";
import CronStatus from "./components/CronStatus";
import CompareSitesViewer from "./components/CompareSitesViewer";
import GraphEachDay from "./components/GraphEachDay";
import Transactions from "./components/Transactions";
import ForecastReportViewer from "./components/ForecastReportViewer";
import AIInsightsPanel from "./components/AIInsightsPanel";
import CarbonSavingsPanel from "./components/CarbonSavingsPanel";
import FnpWaterModule from "./components/FnpWaterModule";

function AppContent() {
  const { user } = useContext(AuthContext);

  return (
    <div className="app-wrapper">
      {/* Show Navbar only if logged in */}
      {user && <Navbar />}
      <div style={{ display: "flex" }}>
        {/* Show side NavbarAdmin only if logged in */}
        {user && <NavbarAdmin />}
        <div className="main-content">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/master-site-manager" element={<PrivateRoute><MasterSiteManager /></PrivateRoute>} />
            <Route path="/masterandsite" element={<PrivateRoute><SiteManager /></PrivateRoute>} />
            <Route path="/today-report-viewer/" element={<PrivateRoute><TodayReportViewer /></PrivateRoute>} />
            <Route path="/daily-report-viewer/" element={<PrivateRoute><DailyReportViewer /></PrivateRoute>} />
            <Route path="/user-manager" element={<PrivateRoute><UserManager /></PrivateRoute>} />
            <Route path="/site-manager" element={<PrivateRoute><SiteViewer /></PrivateRoute>} />
            <Route path="/trigger-reports" element={<PrivateRoute><ReportTrigger /></PrivateRoute>} />
            <Route path="/regular-sms-viewer" element={<PrivateRoute><RegularSMSViewer /></PrivateRoute>} />
            <Route path="/cron-status" element={<PrivateRoute><CronStatus /></PrivateRoute>} />
            <Route path="/compare-sites-viewer" element={<PrivateRoute><CompareSitesViewer /></PrivateRoute>} />
            <Route path="/graph-each-day" element={<PrivateRoute><GraphEachDay /></PrivateRoute>} />
            <Route path="*" element={<PrivateRoute><h1>404 Not Found</h1></PrivateRoute>} />
            <Route path="/transactions" element={<PrivateRoute><Transactions /></PrivateRoute>} />
            <Route path="/forecast" element={<PrivateRoute><ForecastReportViewer /></PrivateRoute>} />
            <Route path="/aiinsights" element={<PrivateRoute><AIInsightsPanel /></PrivateRoute>} />
            <Route path="/carbon" element={<PrivateRoute><CarbonSavingsPanel /></PrivateRoute>} />

            <Route path="/impact/fnp" element={<PrivateRoute><FnpWaterModule /></PrivateRoute>} />

          </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
